export default "__VITE_ASSET__BbK3qkQE__"